"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NETWORK_VIEW = exports.MERCHANT_FULFILLER_VIEW = exports.FULFILLER_VIEW = void 0;
//dashboards 9433
var FULFILLER_VIEW = '15ddf28e-e577-415a-8dd1-54a61ed0a0da'; // dashboards 10400

exports.FULFILLER_VIEW = FULFILLER_VIEW;
var MERCHANT_FULFILLER_VIEW = 'c3dca283-a9e3-4a23-b1b9-da806e3ad214'; // dashboard 8871

exports.MERCHANT_FULFILLER_VIEW = MERCHANT_FULFILLER_VIEW;
var NETWORK_VIEW = '89a8e483-aeb3-4621-bd2e-28b3f0cdd000';
exports.NETWORK_VIEW = NETWORK_VIEW;